module.exports = __webpack_public_path__ + "img/grand-osasis-cancun-2.2ac90fc8.jpg";